export default __webpack_public_path__ + "c1270a97360b7e99161321969c519f37.svg";